import classnames from 'classnames'

// State
import { useListingSearchContext } from 'src/context/listingSearch'

// Components
import { LoadingWrapper } from 'src/Components'

// Relative Components
import Empty from './Empty'
import List from './List'

// Styles
import styles from './Results.module.scss'

const Results = () => {
  const { loading, isInEmptyState, isInNoResultsState } =
    useListingSearchContext()

  const centerDiv = loading || isInEmptyState || isInNoResultsState

  return (
    <>
      <div
        className={classnames(
          styles.firstHalf,
          centerDiv && styles.center,
          !loading && styles.top
        )}
      >
        <LoadingWrapper
          className={classnames('loadingWrapper', { [styles.center]: loading })}
          done={!loading}
        >
          <Empty />
          <List />
        </LoadingWrapper>
      </div>
      <div className={styles.secondHalf} />
    </>
  )
}

export default Results
